import BlogArticlePage from '../components/BlogArticles';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Orchestrating Motion at Scale with the Cartwheel API | Cartwheel',
  'A practical guide to generating, editing, looping, and retargeting motion programmatically at scale.',
);

export default BlogArticlePage;
